/**
 * Section expand/collapse and scroll-to-section for Bid Analysis template.
 */
import { useCallback } from 'react';

export type StateBag = {
  setExpandedSections: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  setActiveSection: (value: React.SetStateAction<string>) => void;
  sectionRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
};

export function useTemplateNavigation(state: StateBag) {
  const { setExpandedSections, setActiveSection, sectionRefs } = state;

  const toggleSection = useCallback(
    (section: string) => {
      setExpandedSections(prev => ({
        ...prev,
        [section]: !prev[section],
      }));
    },
    [setExpandedSections]
  );

  const scrollToSection = useCallback(
    (sectionId: string) => {
      setActiveSection(sectionId);
      const element = sectionRefs.current[sectionId];
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    [setActiveSection, sectionRefs]
  );

  return { toggleSection, scrollToSection };
}
